import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-map-routes',
  templateUrl: './map-routes.component.html',
  styles: [],
})
export class MapRoutesComponent implements OnInit {
  routeIds$: Observable<number[]>;

  constructor(private routeService: RouteService) {}

  ngOnInit(): void {
    this.routeIds$ = this.routeService.routeIds$;
  }
}
